import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {
    DossierExpertRefusRequest as DossierExpertRefusRequestBaseInterface
} from '../../interface/api/DossierExpertRefusRequest';

export type DossierExpertRefusRequestInterface = DossierExpertRefusRequestBaseInterface;

export class DossierExpertRefusRequest extends Hydra implements DossierExpertRefusRequestInterface {

    dossierExpert?: DossierInterface | string | null;

    justification?: string | null;


    constructor(options: DossierExpertRefusRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
